<script>
import TextField from '@/components/form/TextField'
import SelectField from '@/components/form/SelectField'
import MultiField from '@/components/form/MultiField'
import DateField from '@/components/form/DateField'
import ImageField from '@/components/form/ImageField'
import _ from 'lodash'

export default {
  functional: true,
  components: {
    TextField,
    SelectField,
    MultiField,
    DateField,
    ImageField,
  },
  props: {
    form: Object,
    fields: Array,
    updateField: Function,
    hideAlert: {
      type: Function,
      default: () => {},
    },
    hasPhoto: {
      type: Boolean,
      default: false,
    },
    inPopup: {
      type: Boolean,
      default: false,
    },
  },
  render: (h, { props }) => {
    const { form, fields, updateField, hideAlert, hasPhoto, inPopup } = props

    const doHideAlert = value => {
      hideAlert()
    }

    const errorAlert = form.hasError
      ? <v-alert
        value={form.showAlert}
        type="error"
        dismissible
        class="my-0"
        on-input={ doHideAlert }>
        { form.errors.message }
        <div>{ _.isArray(form.errors.errors) ? form.errors.errors.map(err => err[0]).join(', ') : null }</div>
      </v-alert>
      : null

    const successAlert = form.saved
      ? <v-alert
        value={form.showAlert}
        type="success"
        dismissible
        class="my-0"
        on-input={ doHideAlert }>
          OK
      </v-alert>
      : null

    let formFields = fields.map((field, idx) => {
      switch (field.type) {
        case 'list':
          return (
            <SelectField
              key={`select-${idx}`}
              updateField={updateField}
              form={form}
              field={field}
              inPopup={inPopup}
            />
          )
        case 'multilist':
          return (
            <MultiField
              key={`multi-${idx}`}
              updateField={updateField}
              form={form}
              field={field}
              inPopup={inPopup}
            />
          )
        case 'date':
          return (
            <DateField
              key={idx}
              updateField={updateField}
              form={form}
              field={field}
              inPopup={inPopup}
            />
          )
        default:
          return (
            <TextField
              key={idx}
              updateField={updateField}
              form={form}
              field={field}
              inPopup={inPopup}
            />
          )
      }
    })

    const photo = hasPhoto
      ? <ImageField
        updateField={updateField}
        form={form}
      />
      : null

    return (
      <v-form>
        { errorAlert }
        { successAlert }
        <v-container grid-list-lg>
          <v-layout row wrap>
            <v-flex class={{'lg8': hasPhoto}} >
              <v-layout row wrap>
                { formFields }
              </v-layout>
            </v-flex>
            { photo }
          </v-layout>
        </v-container>
      </v-form>
    )
  },
}
</script>

<style>
#file {
  display: none;
}
</style>
